import PatcraftApi from './scripts/patcraft-api';
import { 
    PRODUCT_IMPRESSION_EVENT_NAME, 
    PRODUCT_CLICK_EVENT_NAME, 
    PRODUCT_DETAIL_VIEW_EVENT_NAME, 
    PRODUCT_ADD_TO_CART_EVENT_NAME,
    VIEW_CART_EVENT_NAME,
    BEGIN_CHECKOUT_EVENT_NAME,
    TRANSACTION_EVENT_NAME,
    SEARCH_EVENT_NAME,
    REMOVE_FROM_CART_EVENT_NAME,
    REVIEW_ORDER_EVENT_NAME,
    ITEM_BRAND,
    PRODUCT_LIST,
    IN_STOCK,
    FILTER_BY_FACE_WEIGHT_RANGE
} from './constants/gtm-constants';

//Helper for pushing gtm events
export default {
    removeFromCartEvent: function(product){
        let mappedProduct = mapProduct(product, REMOVE_FROM_CART_EVENT_NAME);
        let gtmObj = getGTMObject(REMOVE_FROM_CART_EVENT_NAME);
        gtmObj.ecommerce.remove.products.push(mappedProduct);
        window.dataLayer.push(gtmObj);
    },
    viewCartEvent: function(productsList, eventName) {
        if (productsList != undefined) {
            let gtmObj = getGTMObject(eventName);
            gtmObj.ecommerce.items = [];
            productsList.map((p,index) => {
                if(p.GTMProduct){
                    let newObj = {};
                    Object.entries(p?.GTMProduct).forEach(([key, value]) => {
                        newObj[key.charAt(0).toLowerCase() + key.slice(1)] = value;
                    });
                    const itemsObj = mapProduct(newObj, VIEW_CART_EVENT_NAME, index)
                    itemsObj.item_list_id = p?.ProductTypeDesc?.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_') ?? undefined;
                    itemsObj.item_list_name = p?.ProductTypeDesc;
                    itemsObj.item_category = p?.ProductTypeDesc;
                    gtmObj.ecommerce.items.push(itemsObj);
                }
            });
            if(eventName == REVIEW_ORDER_EVENT_NAME){
                gtmObj.ecommerce.value = null;
                gtmObj.ecommerce.coupon = "";
                gtmObj.ecommerce.shipping_tier = "";
            }
    
            window.dataLayer.push(gtmObj);
        }
    },
    visualizeIn3dEvent: function(){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: 'visualize-in-3d',
        });
    },
    pushProductImpression: function(items, startIndex, currentFilter, imageType, selectedFilters, inStock, filterByFaceWeight){
        if(!items.length) return;
        let impressions = [];
        let filterColumnsToExclude = ['IsAscendingOrder', "IsEnabledOnSite", "OrderColumn", "PageNumber", "PageSize", "IncludeTotalResultCount"];
        let filterString = Object.entries(currentFilter)
        .filter((el) => el[1] && !filterColumnsToExclude.includes(el[0]))
        .map(f => {
        if(f[0] && f[0].toLowerCase().indexOf("stock") >= 0 && f[1] && f[1] === "0"){
            return `${f[0]}=True`;
        }
        return f.join('=')
        });

        for (let index = startIndex; index < items.length; index++) {
            const el = items[index];
            let mappedProduct = mapProduct(el, PRODUCT_IMPRESSION_EVENT_NAME, index, filterString, imageType == 'swatch' ? 'Main' : 'Room');
            impressions.push(mappedProduct);
        }
        let gtmObj = getGTMObject(PRODUCT_IMPRESSION_EVENT_NAME);
        gtmObj.ecommerce.item_list_id = PRODUCT_LIST.replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_');
        gtmObj.ecommerce.item_list_name = PRODUCT_LIST;   
        Object.entries(selectedFilters).forEach(([k, filter]) => {
            filter.forEach(option => {
                const formattedOption = option.replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_');
                impressions.map((item)=>{
                    item.item_list_id += `-${formattedOption.toLowerCase()}`;
                    item.item_list_name += `-${option.toLowerCase()}`;
                })
                if (gtmObj.ecommerce.item_list_name === PRODUCT_LIST) {
                    gtmObj.ecommerce.item_list_id = "";
                    gtmObj.ecommerce.item_list_name = "";
                    gtmObj.ecommerce.item_list_id += `${formattedOption.toLowerCase()}`;
                    gtmObj.ecommerce.item_list_name += `${option.toLowerCase()}`;
                } else {
                    gtmObj.ecommerce.item_list_id += `-${formattedOption.toLowerCase()}`;
                    gtmObj.ecommerce.item_list_name += `-${option.toLowerCase()}`;
                }
            });
        });
        if (inStock !== null) {
            gtmObj.ecommerce.item_list_id += `-${IN_STOCK.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
            gtmObj.ecommerce.item_list_name += `-${IN_STOCK.toLowerCase()}`;
            impressions.forEach((item) => {
                item.item_list_id += `-${IN_STOCK.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
                item.item_list_name += `-${IN_STOCK.toLowerCase()}`;
            });
        }
        if (filterByFaceWeight) {
            gtmObj.ecommerce.item_list_id += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
            gtmObj.ecommerce.item_list_name += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase()}`;
            impressions.forEach((item) => {
                item.item_list_id += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
                item.item_list_name += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase()}`;
            });
        }
        gtmObj.ecommerce.items = impressions;
        window.dataLayer.push(gtmObj);
    },
    productClickEvent: function(item, index, selectedFilters, inStock, filterByFaceWeight){
        let mappedProduct = mapProduct(item, PRODUCT_CLICK_EVENT_NAME, index);
        let gtmObj = getGTMObject(PRODUCT_CLICK_EVENT_NAME);
        Object.entries(selectedFilters).forEach(([k,filter]) => {
            filter.forEach(option => {
                const formattedOption = option.replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_');
                mappedProduct.item_list_id += `-${formattedOption.toLowerCase()}`;
                mappedProduct.item_list_name += `-${option.toLowerCase()}`;
            });
        });
        gtmObj.ecommerce.item_list_id = mappedProduct?.item_list_id;
        gtmObj.ecommerce.item_list_name = mappedProduct?.item_list_name;  
        if (inStock !== null) {
            gtmObj.ecommerce.item_list_id += `-${IN_STOCK.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
            gtmObj.ecommerce.item_list_name += `-${IN_STOCK.toLowerCase()}`;
            mappedProduct.item_list_id += `-${IN_STOCK.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
            mappedProduct.item_list_name += `-${IN_STOCK.toLowerCase()}`;
        } 
        if (filterByFaceWeight) {
            gtmObj.ecommerce.item_list_id += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
            gtmObj.ecommerce.item_list_name += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase()}`;
            mappedProduct.item_list_id += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_')}`;
            mappedProduct.item_list_name += `-${FILTER_BY_FACE_WEIGHT_RANGE.toLowerCase()}`;
        } 
        gtmObj.ecommerce.items = [mappedProduct];
        window.dataLayer.push(gtmObj);
    },
    productDetailViewLoad: function(product){
        let mappedProduct = mapProduct(product, PRODUCT_DETAIL_VIEW_EVENT_NAME)
        let gtmObj = getGTMObject(PRODUCT_DETAIL_VIEW_EVENT_NAME); 
        gtmObj.ecommerce.items = [mappedProduct];
        window.dataLayer.push(gtmObj);
    },
    addToCartEvent: function(data, index, list){
        PatcraftApi.getProduct(data?.sellingStyleNumber)
        .then((productResponse) => {
            let product = productResponse.data;

            PatcraftApi.getProductColors(data?.sellingStyleNumber)
            .then((colorResponse) => {
                let currentColor = colorResponse.data.find(i => (i?.pdmsData?.colorNumber ?? i?.colorNumber) === data?.sellingColorNumber);
                currentColor.quantity = data.quantity;
                product.colors = [currentColor];
                let gtmObj = getGTMObject(PRODUCT_ADD_TO_CART_EVENT_NAME);
                let mappedProduct = mapProduct(product, PRODUCT_ADD_TO_CART_EVENT_NAME, index);
                gtmObj.ecommerce.items = [mappedProduct];

                window.dataLayer.push(gtmObj);
            })
            .catch(function (error) {
                console.log(error);
                console.log({ type: 'error', title: 'Error', description: 'An error occurred when getting colors for gtm.', event: 'Add To Cart' });
            })
        })
        .catch(function (error) {
            console.log(error);
            console.log({ type: 'error', title: 'Error', description: 'An error occurred when getting product for gtm.', event: 'Add To Cart' });
        });
    },
    checkoutStep(products, checkoutStep, options){
        let gtmObj = getGTMObject(BEGIN_CHECKOUT_EVENT_NAME);
        replaceNulOrEmptyToUndefined(products);
        gtmObj.ecommerce.products = products.map(p => mapProduct(p, BEGIN_CHECKOUT_EVENT_NAME));
        window.dataLayer.push(gtmObj);
    },
    siteSearchEvent: function(query, hits, searchCategory){
        let gtmObj = getGTMObject(SEARCH_EVENT_NAME);
        gtmObj.event = searchCategory ? `search - ${searchCategory}` : 'search - all'
        gtmObj.searchTerm = query;
        gtmObj.numberSearchResults = hits.length;
        if(window.dataLayer && window.dataLayer.length > 0)
        {
            let lastEvent = window.dataLayer[window.dataLayer.length - 1];
            if(lastEvent.event == gtmObj.event && lastEvent.searchTerm == gtmObj.searchTerm && lastEvent.numberSearchResults == gtmObj.numberSearchResults) return;
        }
        window.dataLayer.push(gtmObj);
    },
    transactionEvent: function(products) {
        if(!products) return;
        let orderID = products[0].HandlerOrderId;
    
        let gtmObj = getGTMObject(TRANSACTION_EVENT_NAME);
        gtmObj.ecommerce.transaction_id = orderID || "";
        gtmObj.ecommerce.items = [];
        products[0].Items.map((p,index) => {
            if(p.GTMProduct){
                let newObj = {};
                Object.entries(p?.GTMProduct).forEach(([key, value]) => {
                    newObj[key.charAt(0).toLowerCase() + key.slice(1)] = value;
                });
                const itemsObj = mapProduct(newObj, TRANSACTION_EVENT_NAME, index);
                itemsObj.item_list_id = p?.ProductTypeDesc?.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_') ?? undefined;
                itemsObj.item_list_name = p?.ProductTypeDesc;
                itemsObj.item_category = p?.ProductTypeDesc;
                gtmObj.ecommerce.items.push(itemsObj);
            }
            else{
                let newObj = {};
                newObj['sellingColorNumber'] = p.Item.SellingColorNumber;
                newObj['productTypeDesc'] = p.ProductTypeDesc;
                newObj['collectionName'] = p.Collection;
                newObj['sellingStyleNumber'] = p.Item.SellingStyleNumber;
                newObj['sellingStyleName'] = p.SellingStyleName;
                newObj['price'] = p.Price;
                newObj['quantity'] = p.Quantity;
                newObj['promotion_id'] = null;
                newObj['promotion_name'] = null;
                const itemsObj = mapProduct(newObj, TRANSACTION_EVENT_NAME, index);
                itemsObj.item_list_id = p?.ProductTypeDesc?.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_') ?? undefined;
                itemsObj.item_list_name = p?.ProductTypeDesc;
                itemsObj.item_category = p?.ProductTypeDesc;
                gtmObj.ecommerce.items.push(itemsObj);
            }
        });
        window.dataLayer.push(gtmObj);
    },
    getGTMRefinement: function(property, value){
        if(value == '1' || value.toLowerCase() == 'true'){
            if(property && property.toLowerCase().indexOf('pdq') >= 0){
              value = `PDQ=${value}`; 
            }
            else if(property && property.toLowerCase().indexOf('stock') >= 0){
              value = `InStock=${value}`;
            }
            else{
              value = `${property}=${value}`;
            }            
          }
          return value; 
    }
}

function mapProduct(el, eventName, index, currentFilter, imageType){
    if(!el) return null;
    //on product catalog page field colors contains single color. 
    //Data was added in such way to Algolia
    //On PDP color is a single color object
    let color = el.colors && el.colors.length > 0 ? el.colors[0] : el.color;
    let variant = color ? `${color?.colorNumber}` : el.sellingColorNumber;
    let result = ({
        affiliation: null,
        coupon: null,
        discount: null,
        index:index,
        item_brand: ITEM_BRAND, // is it always patcraft?
        item_category: el.productTypeDesc ?? undefined, // Should it be like Inventory Type - Product Type Desc? Just tile might be confusing
        item_category2: null,
        item_category3: null,
        item_category4: null,
        item_category5:null,
        item_collection: el?.collectionName ?? el?.collection ?? undefined,
        item_id: (el.sellingStyleNumber || el.styleNumber) ?? undefined,
        item_list_id: el.productTypeDesc?.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '_').replace(/\s+/g, '_') ?? undefined,
        item_list_name: el.productTypeDesc ?? undefined,
        item_name: (el.sellingStyleName || el.styleName) ?? undefined,
        item_variant: variant ?? undefined,
        location_id: null,
        price:  el.price ?? 0,
        quantity: el.quantity ?? 1,
    });

    switch(eventName){
        case PRODUCT_IMPRESSION_EVENT_NAME: 
        result = {...result, promotion_id : null, promotion_name : null}
        break;
        case PRODUCT_CLICK_EVENT_NAME: result['index'] = 0; break;
        case PRODUCT_DETAIL_VIEW_EVENT_NAME: result['index'] = 0; break;
        case TRANSACTION_EVENT_NAME: 
        result = {...result, promotion_id : null, promotion_name : null}
        break;
    }

    return result;
}

function getGTMObject(eventName){
    window.dataLayer = window.dataLayer || [];

    let gtmObj = ({
        'event': eventName
    });

    if(eventName !== SEARCH_EVENT_NAME){
        gtmObj['ecommerce'] = {
            'currency': 'USD'
        }
    }

    switch(eventName){
        case PRODUCT_DETAIL_VIEW_EVENT_NAME: 
            gtmObj.event = PRODUCT_DETAIL_VIEW_EVENT_NAME;
            gtmObj.ecommerce = {
                'currency': "",
		        'value': null,
                'items': []
            }; break;
        case PRODUCT_CLICK_EVENT_NAME: 
            gtmObj.event = PRODUCT_CLICK_EVENT_NAME;
            gtmObj.ecommerce = {
                'item_list_id': "product_details",
                'item_list_name': "Product details",
                'items': []
            }; break;
        case PRODUCT_IMPRESSION_EVENT_NAME: 
            gtmObj.event = PRODUCT_IMPRESSION_EVENT_NAME;
            gtmObj.ecommerce = {
                'item_list_id': "products",
                'item_list_name': "Products",
                'items': []
            }; 
            break;
        case PRODUCT_ADD_TO_CART_EVENT_NAME:
            gtmObj.event = PRODUCT_ADD_TO_CART_EVENT_NAME;
            gtmObj.ecommerce= {
                'currency': "",
		        'value': null,
                'items': []
            }; break;
        case BEGIN_CHECKOUT_EVENT_NAME:
            gtmObj.event = BEGIN_CHECKOUT_EVENT_NAME;
            gtmObj.ecommerce = {
                'currency': "",
		        'value': null,
                'coupon': "",
                'items': []
            }; break;
        case SEARCH_EVENT_NAME: 
            gtmObj['searchTerm'] = undefined;
            gtmObj['numberSearchResults'] = undefined;
        break;
        case TRANSACTION_EVENT_NAME:
            gtmObj.event = TRANSACTION_EVENT_NAME;
            gtmObj.ecommerce = {
                "transaction_id": 0,
                "value": null,
                "tax": 0,
                "shipping": 0,
                "currency": "",
                "coupon": "",
                "affiliation": ITEM_BRAND,
                "order_coupon_amount": '',
                "cart_value" : '',
                "payment_type" : '',
                "shipping_tier" : '',
                'items':[]                   
            }
        break;
        case REMOVE_FROM_CART_EVENT_NAME:
            gtmObj.ecommerce['remove'] = {
                products: []
            }
        break;
        case VIEW_CART_EVENT_NAME:
            gtmObj.ecommerce = {
                'currency': "",
		        'value': null,
                'items': []
            }; 
        break;
    }

    return gtmObj;
}

function replaceNulOrEmptyToUndefined(products)
{
    products.forEach(element => {
        for(let propt in element){
            if(element[propt]) continue;
            element[propt] = undefined;
        }
    });
}
